import AbstractColumn from './AbstractColumn'

export default class Column extends AbstractColumn {
  constructor (field) {
    super()
    this.init(field)
  }
}
